import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  MenuItem,
} from "material-ui";
import Formsy from "formsy-react";
import {
  FormsyText,
  FormsyAutoComplete,
  FormsyRadioGroup,
  FormsyRadio,
  FormsySelect,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Loading from "../Loading";
import formatDate from "../../../utils/formatDate";

class EmailMatrixForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      companies: [],
      employees: [],
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
      },
    };

    this.renderSelection = this.renderSelection.bind(this);
    this.fetchMatrix = this.fetchMatrix.bind(this);
    this.renderEmployee = this.renderEmployee.bind(this);
    this.addEmployee = this.addEmployee.bind(this);
    this.removeEmployee = this.removeEmployee.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount() {
    let url = `/api/payroll/getCompanies`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false });
        this.setState({ companies: json.companies });
      });
  }

  submitForm(data) {
    // alert(JSON.stringify(data, null, 4));
    let url = "/api/payroll/updateMatrix";
    let options = {
      method: "put",
      headers: {
        token: this.props.token.jwt,
        Accept: "aplication/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ employees: json });
        alert("Email matrix updated");
      });
  }

  notifyFormError(data) {
    alert("Form error:", JSON.stringify(data, null, 4));
  }

  resetForm() {
    // this.setState({file: '', response: '', isLoading: false})
  }

  fetchMatrix(e, key, payload) {
    let url = `/api/payroll/getMatrix?company=${key}`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false });
        this.setState({ employees: json.employees });
      });
  }

  renderSelection(selection, i) {
    return <MenuItem key={i} primaryText={selection} value={selection} />;
  }

  addEmployee(employee) {
    let { employees } = this.state;
    if (employee) {
      employees.push(employee);
    } else {
      employees.push({
        name: "",
        empId: "",
        email: "",
      });
    }
    this.setState({ employees: employees });
  }

  removeEmployee(i) {
    let employees = this.state.employees;
    employees.splice(i, 1);
    this.setState({ employees: employees });
  }

  renderEmployee(employee, i) {
    let { centerStyle, listStyle, listPaperStyle, listItemStyle } =
      this.state.styles;
    return (
      <Paper style={listPaperStyle} key={i}>
        <Subheader>{`Employee ${i + 1}`}</Subheader>
        <div style={listStyle}>
          <FormsyText
            required
            fullWidth
            style={listItemStyle}
            name={`employees[${i}][name]`}
            floatingLabelText="Name"
            value={employee.name}
          />
          <FormsyText
            required
            fullWidth
            style={listItemStyle}
            name={`employees[${i}][empId]`}
            floatingLabelText="Employee ID"
            value={employee.empId}
          />
          <FormsyText
            fullWidth
            style={listItemStyle}
            name={`employees[${i}][email]`}
            floatingLabelText="Email"
            value={employee.email}
          />
        </div>
        <center>
          <FlatButton
            style={centerStyle}
            label="Remove"
            hoverColor="#e57373"
            onClick={this.removeEmployee.bind(this, i)}
          />
        </center>
      </Paper>
    );
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let { centerStyle } = this.state.styles;
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
        >
          <Formsy.Form
            ref="form"
            onValidSubmit={this.submitForm}
            onInvalidSubmit={this.notifyFormError}
          >
            <div style={centerStyle}>
              <h1 style={{ marginBottom: "1em" }}>Email Matrix Form</h1>
            </div>
            <Divider />
            <Subheader>Company</Subheader>
            <div style={centerStyle}>
              <FormsySelect
                required
                fullWidth
                name="company"
                floatingLabelText="Choose Company"
                onChange={this.fetchMatrix}
              >
                {this.state.companies.map(this.renderSelection)}
              </FormsySelect>
            </div>
            <Divider />
            <Subheader>Employees</Subheader>
            <div style={centerStyle}>
              {this.state.employees.map(this.renderEmployee)}
              <FlatButton
                disabled={!this.state.employees.length > 0}
                label="Add Employee"
                hoverColor="#BDBDBD"
                onClick={this.addEmployee}
              />
            </div>
            <Divider />
            <div style={centerStyle}>
              <br />
              <FlatButton
                disabled={this.state.isLoading}
                type="submit"
                label="Submit"
              />
              <FlatButton
                disabled={this.state.isLoading}
                label="reset"
                onClick={this.resetForm.bind(this)}
              />
            </div>
          </Formsy.Form>
        </Paper>
      );
    }
  }
}

export default EmailMatrixForm;



// WEBPACK FOOTER //
// ./app/components/Payroll/EmailMatrixForm.js